export enum QueryParamName {
  Page = "page",
  Sort = "sort",
  Facets = "facets",
  ItemsPerPage = "size",
  SearchPhrase = "q",
  PreserveUserQuery = "preserveUserQuery",
  Barcode = "barcode",
}
